module.exports = __webpack_public_path__ + "img/gms_10.53a3445a.png";